import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import { sort } from '../data/tsunamiReduxConstants';

export const TSUNAMI_EVENT_SEARCH_REQUEST = 'TSUNAMI_EVENT_SEARCH_REQUEST';
export const TSUNAMI_EVENT_SEARCH_SUCCESS = 'TSUNAMI_EVENT_SEARCH_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_FAILURE = 'TSUNAMI_EVENT_SEARCH_FAILURE';

export const TSUNAMI_EVENT_SEARCH_CLEAR = 'TSUNAMI_EVENT_SEARCH_CLEAR';
export const TSUNAMI_EVENT_SEARCH_CLEAR_REDIRECT = 'TSUNAMI_EVENT_SEARCH_CLEAR_REDIRECT';

export const TSUNAMI_EVENT_SEARCH_REGION_REQUEST = 'TSUNAMI_EVENT_SEARCH_REGION_REQUEST';
export const TSUNAMI_EVENT_SEARCH_REGION_SUCCESS = 'TSUNAMI_EVENT_SEARCH_REGION_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_REGION_FAILURE = 'TSUNAMI_EVENT_SEARCH_REGION_FAILURE';

export const TSUNAMI_EVENT_SEARCH_COUNTRY_REQUEST = 'TSUNAMI_EVENT_SEARCH_COUNTRY_REQUEST';
export const TSUNAMI_EVENT_SEARCH_COUNTRY_SUCCESS = 'TSUNAMI_EVENT_SEARCH_COUNTRY_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_COUNTRY_FAILURE = 'TSUNAMI_EVENT_SEARCH_COUNTRY_FAILURE';

export const TSUNAMI_EVENT_SEARCH_AREA_REQUEST = 'TSUNAMI_EVENT_SEARCH_AREA_REQUEST';
export const TSUNAMI_EVENT_SEARCH_AREA_SUCCESS = 'TSUNAMI_EVENT_SEARCH_AREA_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_AREA_FAILURE = 'TSUNAMI_EVENT_SEARCH_AREA_FAILURE';

export const TSUNAMI_EVENT_SEARCH_RUNUP_REGION_REQUEST = 'TSUNAMI_EVENT_SEARCH_RUNUP_REGION_REQUEST';
export const TSUNAMI_EVENT_SEARCH_RUNUP_REGION_SUCCESS = 'TSUNAMI_EVENT_SEARCH_RUNUP_REGION_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_RUNUP_REGION_FAILURE = 'TSUNAMI_EVENT_SEARCH_RUNUP_REGION_FAILURE';

export const TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_REQUEST = 'TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_REQUEST';
export const TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_SUCCESS = 'TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_FAILURE = 'TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_FAILURE';

export const TSUNAMI_EVENT_SEARCH_RUNUP_AREA_REQUEST = 'TSUNAMI_EVENT_SEARCH_RUNUP_AREA_REQUEST';
export const TSUNAMI_EVENT_SEARCH_RUNUP_AREA_SUCCESS = 'TSUNAMI_EVENT_SEARCH_RUNUP_AREA_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_RUNUP_AREA_FAILURE = 'TSUNAMI_EVENT_SEARCH_RUNUP_AREA_FAILURE';

export const TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_REQUEST = 'TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_REQUEST';
export const TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS = 'TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_FAILURE = 'TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_FAILURE';

export const TSUNAMI_EVENT_SEARCH_DOUBT_TYPE_REQUEST = 'TSUNAMI_EVENT_SEARCH_DOUBT_TYPE_REQUEST';
export const TSUNAMI_EVENT_SEARCH_DOUBT_TYPE_SUCCESS = 'TSUNAMI_EVENT_SEARCH_DOUBT_TYPE_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_DOUBT_TYPE_FAILURE = 'TSUNAMI_EVENT_SEARCH_DOUBT_TYPE_FAILURE';

export const TSUNAMI_EVENT_SEARCH_VALIDITY_REQUEST = 'TSUNAMI_EVENT_SEARCH_VALIDITY_REQUEST';
export const TSUNAMI_EVENT_SEARCH_VALIDITY_SUCCESS = 'TSUNAMI_EVENT_SEARCH_VALIDITY_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_VALIDITY_FAILURE = 'TSUNAMI_EVENT_SEARCH_VALIDITY_FAILURE';

export const TSUNAMI_EVENT_SEARCH_CAUSE_REQUEST = 'TSUNAMI_EVENT_SEARCH_CAUSE_REQUEST';
export const TSUNAMI_EVENT_SEARCH_CAUSE_SUCCESS = 'TSUNAMI_EVENT_SEARCH_CAUSE_SUCCESS';
export const TSUNAMI_EVENT_SEARCH_CAUSE_FAILURE = 'TSUNAMI_EVENT_SEARCH_CAUSE_FAILURE';

export const TSUNAMI_EVENT_DATA_SORT = 'TSUNAMI_EVENT_DATA_SORT';

const initialState = fromJS({
  searching: false,
  fetched: false,
  tsunamiEvents: [],
  queryParameters: {},
  searchRedirect: false,

  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchingAreas: false,
  areas: [],

  fetchedRunupRegions: false,
  runupRegions: [],
  fetchedRunupCountries: false,
  runupCountries: [],
  fetchingRunupAreas: false,
  runupAreas: [],
  fetchedRunupMeasurementTypes: false,
  runupMeasurementTypes: [],
  fetchedValidities: false,
  validities: [],
  fetchedCauses: false,
  causes: [],
  fetchedCauseCodes: false, // TODO: is this used?
  causeCodes: [],

  sort,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const tsunamiEventSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case TSUNAMI_EVENT_SEARCH_CLEAR_REDIRECT:
      return state.set('searchRedirect', false);
    case TSUNAMI_EVENT_SEARCH_CLEAR:
      return initialState.merge(fromJS({
        sort: state.get('sort'),
      }));
    case TSUNAMI_EVENT_DATA_SORT:
      return state.merge(fromJS({
        tsunamiEvents: basicSort(action.sort, state.get('tsunamiEvents')),
        sort: action.sort,
      }));
    case TSUNAMI_EVENT_SEARCH_REQUEST:
      return state.merge(fromJS({
        searching: true,
        fetched: false,
        queryParameters: action.queryParameters,
        searchRedirect: Boolean(action.searchRedirect),
      }));
    case TSUNAMI_EVENT_SEARCH_SUCCESS:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
        tsunamiEvents: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case TSUNAMI_EVENT_SEARCH_FAILURE:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
      }));

    case TSUNAMI_EVENT_SEARCH_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case TSUNAMI_EVENT_SEARCH_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case TSUNAMI_EVENT_SEARCH_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case TSUNAMI_EVENT_SEARCH_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case TSUNAMI_EVENT_SEARCH_AREA_REQUEST:
      return state.merge(fromJS({
        fetchingAreas: true,
      }));
    case TSUNAMI_EVENT_SEARCH_AREA_SUCCESS:
      return state.merge(fromJS({
        fetchingAreas: false,
        areas: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_AREA_FAILURE:
      return state.merge(fromJS({
        fetchingAreas: false,
        areas: initialState.get('areas'),
      }));

    case TSUNAMI_EVENT_SEARCH_RUNUP_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRunupRegions: false,
      }));
    case TSUNAMI_EVENT_SEARCH_RUNUP_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupRegions: true,
        runupRegions: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_RUNUP_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRunupRegions: true,
      }));

    case TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedRunupCountries: false,
      }));
    case TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupCountries: true,
        runupCountries: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedRunupCountries: true,
      }));

    case TSUNAMI_EVENT_SEARCH_RUNUP_AREA_REQUEST:
      return state.merge(fromJS({
        fetchingRunupAreas: true,
      }));
    case TSUNAMI_EVENT_SEARCH_RUNUP_AREA_SUCCESS:
      return state.merge(fromJS({
        fetchingRunupAreas: false,
        runupAreas: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_RUNUP_AREA_FAILURE:
      return state.merge(fromJS({
        fetchingRunupAreas: false,
        runupAreas: initialState.get('runupAreas'),
      }));


    case TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_REQUEST:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: false,
      }));
    case TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: true,
        runupMeasurementTypes: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_FAILURE:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: true,
      }));

    case TSUNAMI_EVENT_SEARCH_VALIDITY_REQUEST:
      return state.merge(fromJS({
        fetchedValidities: false,
      }));
    case TSUNAMI_EVENT_SEARCH_VALIDITY_SUCCESS:
      return state.merge(fromJS({
        fetchedValidities: true,
        validities: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_VALIDITY_FAILURE:
      return state.merge(fromJS({
        fetchedValidities: true,
      }));

    case TSUNAMI_EVENT_SEARCH_CAUSE_REQUEST:
      return state.merge(fromJS({
        fetchedCauses: false,
      }));
    case TSUNAMI_EVENT_SEARCH_CAUSE_SUCCESS:
      return state.merge(fromJS({
        fetchedCauses: true,
        causes: action.response.items,
      }));
    case TSUNAMI_EVENT_SEARCH_CAUSE_FAILURE:
      return state.merge(fromJS({
        fetchedCauses: true,
      }));

    default:
      return state;
  }
};
